<template>
    <div>
        <nav-bar-main></nav-bar-main>
          <b-alert
            v-if="plantDetails != null && plantDetails.plant_type == 'basic'"
            show
            variant="warning"
            style="display:inline-block;width:100%"
          >
              <BannerPro/>
          </b-alert>

          <b-alert
            v-if="plantDetails != null && $store.getters.isProExpired"
            show
            variant="warning"
            style="display:inline-block;width:100%"
          >
              <BannerProExpired/>
          </b-alert>

        <!-- alert per feedback dei comandi -->
        <b-row class="alert-feeback-command">
                <b-col lg="12" md="12">
                        <b-alert v-for="(alert,indexA) in alerts" :show="alert.timeLeft" v-bind:key="indexA" :variant="alert.state"
                                dismissible
                                fade
                                @dismissed="alert.timeLeft=0"
                                @dismiss-count-down="alert.countDownChanged">
                                <div>
                                <i v-if="alert.state=='danger'" class="fa fa-1x fa-exclamation-circle mr-2"></i>
                                <i v-if="alert.state=='success'" class="fa fa-1x fa-check-circle mr-2"></i>
                                <div class="pb-3" style="display:inline; font-size:13px; height:15px;">{{alert.msg}}</div></div>
                        </b-alert>
                 </b-col>
        </b-row>

        <ErrorBanner />
        <Loader />

        <div v-if="plantDetails != null && sceneDetails !=null"  class="animated fadeIn container-fluid">

            <b-row class="mt-4">
                <b-col v-for="(ambiente,index) in ambienti" :key="'amb-'+index"  xl="4" lg="6" md="12" sm="12">
                    <b-card border-variant="primary" body-class="nopad">

                        <div slot="header">
                            {{ambiente.name}}
                            <div class="card-header-actions">
                                <b-link href="#" class="card-header-action btn-close" @click="eliminaAmbiente(ambiente,index)" >
                                    <i class="fa fa-trash"></i>
                                </b-link>
                            </div>
                        </div>

                        <!-- image with scenari -->
                        <b-card
                            overlay
                            :id="'imgDiv'+index"
                            :img-src="imageUrl(ambiente.id)" fluid @click="apriModal(index)" @load="picReady(ambiente.id)"
                            >
                        <b-card-text v-if="sceneFiltered(ambiente.id).length > 0">
                             <b-row>
                                <b-col cols="6">
                                </b-col>
                                <b-col cols="6">
                                    <div>
                                        <h5 class="p-2 list-scene">{{$t("scenario.list_scene")}}</h5>

                                        <div style="height:200px;overflow:auto">
                                            <b-list-group v-for="item in sceneFiltered(ambiente.id)" v-bind:key="item.sceneId">
                                                <b-list-group-item class="list-scene">
                                                    <h6 class="ml-1">{{item.sceneName}}</h6>
                                                </b-list-group-item>
                                            </b-list-group>
                                         </div>

                                    </div>
                                </b-col>
                             </b-row>
                        </b-card-text>
                       </b-card>
                    </b-card>

                </b-col>
                <b-col>
                    <b-button v-if="$store.getters.userRole =='installer' || $store.getters.userRole =='collab'" @click="showModalDisclaimer()" ><span style="font-size:40px; font-weight: bold">+</span><br/>{{this.$t("scenario.add_zone")}}</b-button>
                </b-col>
                             <!-- Tabella scenari -->

            </b-row>




        </div>

          <!-- Modal Disclaimer su upload photo-->
          <b-modal
          ref="modalDisclaimerPhoto"
          id="modal-disclaimer-photo"
          :title="$t('settings.normaTitle')"
          :ok-title="$t('settings.normaAccept')"
          @ok="accettazioneDisclaimerPhoto"
      >
          <label for="typo-label">
          <disclaimer-photo-ITA v-if="$t('language')=='IT'"></disclaimer-photo-ITA>
          <disclaimer-photo-GER v-if="$t('language')=='DE'"></disclaimer-photo-GER>
          <disclaimer-photo-ENG v-else></disclaimer-photo-ENG>
          </label>
      </b-modal>

        <!-- modal scenario -->
        <b-modal v-if="currentAmbiente != null && currentAmbiente.name != null" :id="'modal-scenario'" size="xl" :hide-footer="true" @show="apertoDettaglioMappa">

            <template v-slot:modal-header="{ close }">
                <b-row class="ModalPlanimetrieHeader">
                    <b-col cols="12"><h5 >{{$t('scenario.zone')}}</h5></b-col>
                    <b-col cols="7">
                        <span v-if="updatingName">{{currentAmbiente.name}}</span>
                        <b-form-input v-if="!updatingName" v-model="currentAmbiente.name" :placeholder="$t('scenario.set_name')"></b-form-input>
                    </b-col>
                    <b-col cols="4">
                        <b-button @click="chiudiDettaglioMappa($event)" variant="light" class="mr-1"><span class="typo-label" :content="$t('planimetry.save')" v-tippy="{ placement : 'bottom',  arrow: true}"><i class="fa fa-save" style="color:#0090CD"></i></span></b-button>
                    </b-col>
                    <b-col cols="1" class="float-right">
                        <button class="close close-x" @click="chiudiDettaglioMappa($event)">x</button>
                    </b-col>
                </b-row>
            </template>

            <b-container fluid>
                <b-row>
                    <b-col  sm="6" md="7" lg="8">
                        <div class="imgDiv" :id="'imgDivBig'" style="border:2px solid black; overflow: hidden;">
                            <b-img id="imgBig" ref="imgBig" :src="imageUrl(currentAmbiente.id)" fluid ondragstart="return false" @load="bigImgLoaded" />
                            <b-button variant="warning" class="uploadButton"><i class="cui-cloud-upload icons" @click="uploadImg"></i></b-button>
                            <div id="dropzoneContainer" v-if="showDropZone">
                                <b-button variant="danger" class="closeButton"><i class="fa fa-window-close" @click="closeDropZone"></i></b-button>
                                <vue-dropzone v-if="showDropZone"  ref="myVueDropzone" id="dropzone" :options="dropZoneOptions" v-on:vdropzone-file-added="fileAdded" v-on:vdropzone-sending="sendingImage" ></vue-dropzone>
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="6" md="5" lg="4" class="lampList">
                        <b-tabs v-model="tabIndex" class="PlanimetrieTabs">

                            <!-- elenco scenari -->

                            <b-tab v-if="this.ruoloUtente(this.$store.getters.userId)=='installer' || this.ruoloUtente(this.$store.getters.userId)=='collab' ||  this.$store.state.user.usertype=='admin'" :title="$t('scene.scene_list')" lazy>
                                <!-- <p class="ml-2">{{$t('scene.scene_search')}}</p> -->

                                <b-row style="display: flex; align-items: center">
                                    <b-col cols="6">
                                        <!-- <b-input-group class="ml-2">
                                            <b-form-input type="text" v-model="filtro"></b-form-input>

                                            <b-input-group-append>
                                                <b-button variant="primary" @click="filtro = ''"><i class="fa fa-eraser"></i></b-button></i></b-button>
                                            </b-input-group-append>
                                        </b-input-group> -->
                                    </b-col>

                                     <!-- aggiungi scena -->
                                    <b-col cols="6">
                                       <add-scene :ambientId="this.currentAmbiente.id" class="mt-4"></add-scene>
                                    </b-col>
                                </b-row>

                                <!--<b-container fluid>-->
                                <table class="table tabLampadeDragDrop mt-2">
                                    <thead>
                                        <tr>
                                            <th style="width: 40%">{{$t("scene.scene_name")}}</th>
                                            <th style="width: 40%"></th>
                                            <th style="width: 20%"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(scene,index) in sceneFiltered(this.currentAmbiente.id)" :key="'row-'+index" :id="'scene-'+scene.id">
                                             <td style="width: 40%;">{{scene.sceneName}}</td>
                                             <td style="width: 40%">
                                                <b-button variant="primary" class="mr-3" @click="activateScene(scene)">
                                                    {{$t("scene.active_scene")}}
                                                </b-button>
                                             </td>
                                             <td style="width: 20%">
                                                <b-button class="float-right"><i class="fas fa-trash-alt" style="color:#0090CD" @click="removeScene(scene)"></i></b-button>
                                                 <edit-scene :scene="scene"></edit-scene>
                                                <!-- <b-button class="float-right"><i class="fas fa-edit" style="color:#0090CD" @click="editScene(scene)"></i></b-button> -->
                                            </td>
                                            <td><span class="float-right">
                                                </span></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!--</b-container>-->
                            </b-tab>
                            </show-at>
                        </b-tabs>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>

        <b-modal
        ref="modal-edit-scene"
        size="lg"
        :id="'modal-edit-scene'+this._uid"
        :saveSubmit="saveSubmit"
        :title="$t('scene.edit_modal_title')"
        :ok-title="$t('user_modal.button_save')"
        :cancel-title="$t('user_modal.button_cancel')"
        @ok="handleOk"
        >
            <b-row>
            <b-col cols="9">

                <!--input name of scene -->
                <b-form-group class="ml-2">
                    <label class="typo-label">{{$t("scene.label_scene_name")}}</label>
                    <b-form-input
                        v-model="currentScene.sceneName"
                        type="text"
                        :state="validation_sceneName"
                    ></b-form-input>
                    <b-form-invalid-feedback
                        :state="validation_sceneName"
                    >{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                </b-form-group>

                <!-- label cu group selection-->
                <b-row class="px-3 py-2 mt-2">
                <b-col cols="4">
                        <label class="typo-label">{{$t("collection.label_select_cu")}}</label>
                    </b-col>
                    <b-col cols="5">
                        <label class="typo-label">{{$t("scene.label_select_scene")}}</label>
                    </b-col>
                </b-row>

                <!-- label cu group selection-->
                <div v-if="currentScene.collections">
                <div v-for="(item,pos) in currentScene.collections.length" :key="pos" class="px-3 mb-3">
                     <b-row>
                        <!-- select central unit -->
                        <b-col cols="4">
                            <b-form-select v-model="currentScene.collections[pos].cu" @change="onChangeCentEdit($event)"  :state="validation_collectionCu">
                                <option
                                v-for="(option, idx) in cu_options"
                                :key="idx"
                                :value="option"
                                :title="option"
                                >
                                {{ option }}
                            </option>
                            </b-form-select>
                            <b-form-invalid-feedback :state="validation_collectionCu">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                        </b-col>

                        <!-- select scene -->
                        <b-col cols="5">
                            <b-form-select v-model="currentScene.collections[pos].scene" :state="validation_collectionScene">
                                <option
                                    v-for="(option, idx) in scene_options"
                                    :key="idx"
                                    :value="option"
                                    :title="option"
                                    >
                                    {{ option }}
                                </option>
                            </b-form-select>
                            <b-form-invalid-feedback :state="validation_collectionScene">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                        </b-col>

                        <!-- plus button -->
                        <b-col cols="1">
                             <b-button style="color: #0090CD" @click="addInput()"><i class="fas fa fa-1x fa-plus no-border"></i></b-button>
                        </b-col>

                        <!-- remove button -->
                        <b-col cols="1">
                            <b-button v-if="pos>0" @click="function(){itemsScene.splice(pos)}"><i class="fa fa-times pt-1"></i></b-button>
                        </b-col>

                    </b-row>
                </div>
                </div>
                 <!--   <b-form-group class="ml-2">
                        <label class="typo-label">{{$t("collection.label_select_cu")}}</label>
                        <b-form-input
                            v-model="item.cu"
                            type="text"
                            :state="validation_collectionCu"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group class="ml-2">
                        <label class="typo-label">{{$t("collection.label_select_scene")}}</label>
                        <b-form-input
                            v-model="item.scene"
                            type="text"
                            :state="validation_collectionScene"
                        ></b-form-input>
                    </b-form-group>
                </div>
                </div>   -->

                <!-- label collection selection-->
                <!-- <b-row class="px-3 py-2 mt-2">
                <b-col cols="6">
                        <label class="typo-label">{{$t("scene.label_select_c")}}</label>
                    </b-col>
                <b-col cols="4">
                        <label class="typo-label">{{$t("scene.label_light_level")}}</label>
                    </b-col>
                </b-row>

                <div v-for="(itemC,posC) in this.itemsCollection" :key="'coll_'+posC" class="px-3 mb-3">
                    <b-row> -->
                        <!-- select collection -->
                        <!-- <b-col cols="6">
                            <b-form-select v-model="itemC.collection" :options="c_options" :state="validation_collection"></b-form-select>
                            <b-form-invalid-feedback :state="validation_collection">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                        </b-col>
                        <b-col cols="4">
                            <b-form-select v-model="itemC.level" :state="validation_collection">
                                <b-form-select-option value="off" >OFF</b-form-select-option>
                                <b-form-select-option value="auto" >AUTO</b-form-select-option>
                                <b-form-select-option value="5" >5%</b-form-select-option>
                                <b-form-select-option value="10" >10%</b-form-select-option>
                                <b-form-select-option value="15" >15%</b-form-select-option>
                                <b-form-select-option value="20" >20%</b-form-select-option>
                                <b-form-select-option value="25" >25%</b-form-select-option>
                                <b-form-select-option value="30" >30%</b-form-select-option>
                                <b-form-select-option value="35" >35%</b-form-select-option>
                                <b-form-select-option value="40" >40%</b-form-select-option>
                                <b-form-select-option value="45" >45%</b-form-select-option>
                                <b-form-select-option value="50" >50%</b-form-select-option>
                                <b-form-select-option value="55" >55%</b-form-select-option>
                                <b-form-select-option value="60" >60%</b-form-select-option>
                                <b-form-select-option value="65" >65%</b-form-select-option>
                                <b-form-select-option value="70" >70%</b-form-select-option>
                                <b-form-select-option value="75" >75%</b-form-select-option>
                                <b-form-select-option value="80" >80%</b-form-select-option>
                                <b-form-select-option value="85" >85%</b-form-select-option>
                                <b-form-select-option value="90" >90%</b-form-select-option>
                                <b-form-select-option value="95" >95%</b-form-select-option>
                                <b-form-select-option value="100" >100%</b-form-select-option>
                            </b-form-select>
                            <b-form-invalid-feedback :state="validation_collection">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                        </b-col> -->

                        <!-- plus button -->
                        <!-- <b-col cols="1">
                         <b-button v-if="posC == itemsCollection.length-1" style="color: #0090CD" @click="addInputCollection(posC)"><i class="fas fa fa-1x fa-plus no-border"></i></b-button>
                        </b-col>   -->

                        <!-- remove button -->
                        <!-- <b-col cols="1">
                            <b-button v-if="posC>0" @click="function(){itemsCollection.splice(posC,1)}"><i class="fa fa-times pt-1"></i></b-button>
                        </b-col>

                    </b-row>
                </div>
                <b-row>
                    <b-col class="ml-3">
                        <label class="typo-label" style="display:block">{{$t("scene.label_scene_mode")}}</label>
                        <b-form-select v-model="currentScene.sceneMode" style="width: 250px" :state="validation_mode">
                            <b-form-select-option value="" disabled>Seleziona</b-form-select-option>
                            <b-form-select-option value="manual">{{$t('scene.mode_manual')}}</b-form-select-option>
                            <b-form-select-option value="input">{{$t('scene.mode_input')}}</b-form-select-option>
                            <b-form-select-option value="program">{{$t('scene.mode_program')}}</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <div v-if="currentScene.sceneMode == 'input'" class="mt-2 ml-2">
                    <label class="typo-label" style="display:block">{{$t("scene.label_input")}}</label>
                    <b-form-select v-model="currentScene.sceneInput" style="width: 250px" :state="validation_input">
                        <b-form-select-option value="" disabled>Seleziona</b-form-select-option>
                        <b-form-select-option value="1">{{$t('scene.label_input')}} 1</b-form-select-option>
                        <b-form-select-option value="2">{{$t('scene.label_input')}} 2</b-form-select-option>
                        <b-form-select-option value="3">{{$t('scene.label_input')}} 3</b-form-select-option>
                        <b-form-select-option value="4">{{$t('scene.label_input')}} 4</b-form-select-option>
                    </b-form-select>
                </div>

                <div v-if="currentScene.sceneMode == 'program'" class="mt-2 ml-3">
                    <label class="typo-label">{{$t("scene.label_days")}} </label><b-button variant="outline-primary" size="sm" class="ml-2" @click="selectAllDays">{{$t("scene.every_day")}}</b-button>
                    <b-form-checkbox-group v-model="currentScene.program.days" :state="validation_days">
                    <b-row class="pl-2">

                        <b-col cols="1">
                            <label>Lun</label><br/>
                            <b-form-checkbox id="chk1" value="1"  />
                        </b-col>
                        <b-col cols="1">
                            <label>Mar</label><br/>
                            <b-form-checkbox id="chk2" value="2"  />
                        </b-col>
                        <b-col cols="1">
                            <label>Mer</label><br/>
                            <b-form-checkbox id="chk3" value="3" />
                        </b-col>
                        <b-col cols="1">
                            <label>Gio</label><br/>
                            <b-form-checkbox id="chk4" value="4"/>
                        </b-col>
                        <b-col cols="1">
                            <label>Ven</label><br/>
                            <b-form-checkbox id="chk5" value="5"  />
                        </b-col>
                        <b-col cols="1">
                            <label>Sab</label><br/>
                            <b-form-checkbox id="chk6" value="6"  />
                        </b-col>
                        <b-col cols="1">
                            <label>Dom</label><br/>
                            <b-form-checkbox id="chk7" value="7"  />
                        </b-col>
                        <b-col cols="5" />
                        <b-col cols="12">
                            <b-form-invalid-feedback :state="validation_days">{{$t("scene.validation_days")}}</b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                    </b-form-checkbox-group>

                    <b-row class="mt-2">
                        <b-col cols="4">
                            <label class="typo-label">{{$t("scene.label_activation_time")}} </label>
                            <b-form-select v-model="currentScene.program.timeMode" :state="validation_timeMode">
                                <b-form-select-option value="" disabled>Seleziona</b-form-select-option>
                                <b-form-select-option value="dawn">{{$t('scene.label_time_dawn')}}</b-form-select-option>
                                <b-form-select-option value="sunset">{{$t('scene.label_time_sunset')}}</b-form-select-option>
                                <b-form-select-option value="exact">{{$t('scene.label_time_exact')}}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="3" v-if="currentScene.program.timeMode == 'dawn' || currentScene.program.timeMode == 'sunset'">
                            <label>Differenza</label>
                            <b-form-select v-model="currentScene.program.timeDiff" :options="timeDiffOptions"></b-form-select>
                        </b-col>
                        <b-col cols="4" v-if="currentScene.program.timeMode == 'exact'">
                            <label>Orario</label>
                            <b-form-timepicker v-model="currentScene.program.time" locale="it" hourCycle='h23' :hour12="false" class="datepicker-orario" :state="validation_time" />
                        </b-col>
                    </b-row>

                    <b-row class="mt-2">
                        <b-col cols="4">
                            <label for="period-select">{{$t("scene.label_activation_date")}} </label>
                            <b-form-select id="period-select" v-model="currentScene.program.dateMode" :state="validation_dateMode">
                                <b-form-select-option value="" disabled>Seleziona</b-form-select-option>
                                <b-form-select-option value="always">{{$t('scene.label_date_always')}}</b-form-select-option>
                                <b-form-select-option value="interval">{{$t('scene.label_date_period')}}</b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col v-if="currentScene.program.dateMode == 'interval'">
                            <label for="from-datepicker">Dal:</label>
                            <b-form-datepicker id="from-datepicker" :date-format-options="{ day: 'numeric', month: 'numeric' }" locale="it" v-model="currentScene.program.dateFrom" :state="validation_date" class="datepicker-data"></b-form-datepicker>
                        </b-col>
                        <b-col v-if="currentScene.program.dateMode == 'interval'">
                            <label for="to-datepicker">Al:</label>
                            <b-form-datepicker id="to-datepicker" :date-format-options="{ day: 'numeric', month: 'numeric' }" locale="it" v-model="currentScene.program.dateTo" :state="validation_date" class="datepicker-data"></b-form-datepicker>
                        </b-col>
                    </b-row>


                </div>
                <b-row class="mt-2">
                    <b-col cols="4" class="pl-4">
                        <label for="chkEnabled">{{$t("scene.label_activated")}} </label>
                        <b-form-checkbox id="chkEnabled" v-model="currentScene.sceneEnabled" switch size="lg" />
                    </b-col>

                </b-row> -->

                </b-col>
            </b-row>
        </b-modal>

    </div>
</template>

<script>

import Vue from 'vue'

import NavBarMain from '@/components/NavBarMain';
import vue2Dropzone from 'vue2-dropzone';
import DisclaimerPhotoITA from '@/locales/DisclaimerPhotoITA';
import DisclaimerPhotoENG from '@/locales/DisclaimerPhotoENG';
import DisclaimerPhotoGER from '@/locales/DisclaimerPhotoGER';
import BannerPro from '@/components/BannerPro';
import BannerProExpired from '@/components/BannerProExpired';
import {showAt, hideAt} from 'vue-breakpoints';
import { mapState } from 'vuex';
import AddScene from '@/components/AddScene';
import EditScene from '@/components/EditScene';
import ErrorBanner from '@/components/ErrorBanner';

export default {
    name: 'Scenari',
    components: {
        NavBarMain,
        Event,
        BannerPro,
        BannerProExpired,
        DisclaimerPhotoITA,
        DisclaimerPhotoENG,
        DisclaimerPhotoGER,
        hideAt,
        showAt ,
        AddScene,
        EditScene,
        vueDropzone: vue2Dropzone,
        ErrorBanner
    },
    props: ['plantId'],
    data() {
        return {
            section: "scenari",
            filtroScene:null,
            editingSceneType:"new",
            tabIndex: 0,
            filtro: "",
            tableData: null,
            sceneName: "",
            saveSubmit: "false",
            itemsCollection:[
                {
                collection: '',
                }
            ],
            c_options:[],
            timeDiffOptions: [],
            currentScene: {
            },
            currentAmbiente: {},
            updatingName: false,
            cu_options:[],
            scene_options:[],
            showDropZone: false,
            imgLoaded: false,
            imgUploaded: false,
            pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,
            picLoaded: {},
            dropZoneOptions: {
                url: process.env.VUE_APP_API_REST_URL,
                maxFilesize: 1.5,
                acceptFiles: "image/*",
                autoProcessQueue: false,
                autoQueue: false,
                maxFiles: 1
            },
            alerts: [],
            theme: 'bootstrap4',
            template: 'default',
        }

    },
    computed: {
        ...mapState(['loading','error','commandsPending','commandResponse']),
         cuIdList()
        {
        console.log("Unit details", this.$store.state.plantUnits);
        var cuList=[];
        for(var i=0;i<this.$store.state.plantUnits.length;i++)
        {
            //esclusione delle centrali cablecom
            if (this.$store.state.plantUnits[i].cu_type != "cablecom")
            cuList.push(this.$store.state.plantUnits[i].cu_type+"_"+this.$store.state.plantUnits[i].cu_id);
        }
        return cuList;
        },
        ambienti() {
            if (this.plantDetails == null || this.plantDetails[this.section] == null) return [];
            let self = this;

            return this.plantDetails[this.section].map(function(a){
                console.log("mappo scenari");
                console.log("scenari ",a);
                return a;
            });
        },
        rndId() {
            return Math.random();
        },
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null){
                this.tableData = [];
                return null;
            }
            if (plant.id != this.plantId) return null;
            return plant;
        },
        sceneDetails(){
            this.tableData = this.$store.state.plantScenes;
            console.log("Scenes: ",this.tableData);
            return this.tableData;
        },
        unitsDetails() {
             console.log("Units: ",this.$store.state.plantUnits);
            return this.$store.state.plantUnits;
        },
        allTableData() {
            return this.$store.state.plantUnits || [];
        },
        validation_sceneName() {
            if (this.saveSubmit == true) return this.currentScene.sceneName.length > 0;
            return null;
        },
        validation_collectionCu() {
            if (this.saveSubmit == true) return this.currentScene.collections[0].cu != "" ;
        },
        validation_collectionScene() {
            if (this.saveSubmit == true) return  this.currentScene.collections[0].scene != "";
        },
        validation_collection() {
            if (this.saveSubmit == true) return this.itemsCollection[0].collection != "" ;
            return null;
        },
        validation_mode() {
            if (this.saveSubmit == true) return this.currentScene.sceneMode != "";
            return null;
        },
        validation_days() {
            if (this.saveSubmit == true ) {
                if (this.currentScene.sceneMode != 'program') return true;
                return this.currentScene.program.days != null && this.currentScene.program.days.length > 0;
            }
            return null;
        },
        validation_input() {
            if (this.saveSubmit == true ) {
                if (this.currentScene.sceneMode != 'input') return true;
                return this.currentScene.sceneInput != null && this.currentScene.sceneInput != '';
            }
            return null;
        },
        validation_time() {
            if (this.saveSubmit == true ) {
                if (this.currentScene.sceneMode != 'program') return true;
                if (this.currentScene.program.timeMode != 'exact') return true;
                console.log("time:", this.currentScene.program.time);
                return this.currentScene.program.time != null;
            }
            return null;
        },
        validation_dateMode() {
            if (this.saveSubmit == true ) {
                if (this.currentScene.sceneMode != 'program') return true;
                return this.currentScene.program.dateMode != null && this.currentScene.program.dateMode != '';
            }
            return null;
        },
        validation_date() {
            if (this.saveSubmit == true ) {
                if (this.currentScene.sceneMode != 'program') return true;
                if (this.currentScene.program.dateMode != 'interval') return true;
                console.log("date:", this.currentScene.program.dateFrom, this.currentScene.program.dateTo);
                return this.currentScene.program.dateFrom != null && this.currentScene.program.dateTo != null;
            }
            return null;
        },
        validation_timeMode() {
            if (this.saveSubmit == true ) {
                if (this.currentScene.sceneMode != 'program') return true;
                return this.currentScene.program.timeMode != null && this.currentScene.program.timeMode != '';
            }
            return null;
        }
    },
    mounted() {
        console.log("scenari mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails + ", collections:" + this.$store.state.plantCollections)
        //window.addEventListener('resize', this.handleResize)

        this.buildTimeDiffOptions();
        //var dataReady = this.loadData();
        //console.log("gestionezone mounted dataReady " + dataReady);
        if (this.plantDetails != null && (this.$store.state.plantScenes==null)) {
            var dataReady = this.loadData();
            console.log("scenari mounted dataReady " + dataReady);

        }

        if (this.$store.state.plantCollections != null) {
            this.c_options = this.$store.state.plantCollections.map(c => { return {value: c.collectionId, text: c.collectionName}});
        }

    },
    updated() {
        console.log("scenari updated, idImpianto=" + this.plantId+", plantDetails=", this.plantDetails+ ", error:" + this.error+", collections:" + this.$store.state.plantCollections)
        if (this.plantDetails == null && this.error == null && this.$store.state.user != null) {
            this.$store.dispatch('loadPlantDetails', this.plantId)
        }
    },

    watch: {
        loading(val,oldval) {
            console.log("scenari loading changed:" + val+", error=" + this.error)
            if (val == false && this.error == null) {
                var dataReady = this.loadData();
                console.log("scenari loading dataReady " + dataReady);

                /*if (dataReady) {
                    this.c_options = this.$store.state.plantCollections.map(c => { return {value: c.collectionId, text: c.collectionName}});
                }*/
            }
        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
        },
        commandsPending(val,oldval) {
            console.log("commandsPending " + val, "configInProgress =" + this.configInProgress);
        },
        commandResponse(val,oldval) {
            //console.log("cambiata commandResponse ->", val);
            let resp = val;
            console.log("analizzo la risposta, loop= " + this.loop  , resp);
            if (!resp.pending && resp.command != null) {
                if (resp.error != null && resp.error != "") {
                    console.log("resp error",resp.error);
                    var alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg: "Resp error"
                    }
                    this.alerts.push(alert);
                } else {
                    console.log("risposta ok per comando " + resp.command);
                     var alert = {
                                timeLeft: 5,
                                state: "success",
                                msg: "Eseguito comando " + resp.command + " su centrale " + resp.cu,
                                countDownChanged: function(cd) {
                                    //timeLeft = cd;
                                    console.log("countdownchanged:" + cd)
                                }
                            }
                            this.alerts.push(alert);
                    switch (resp.command) {
                        case 'disclaimerPhotoAccepted':
                            this.aggiungiPianta();
                            break;
                        case 'plantCollections':
                            this.c_options = resp.response.map(c => { return {value: c.collectionId, text: c.collectionName}});
                            break;
                        case 'saveScene':
                                this.$bvModal.hide('modal-edit-scene');
                                this.$store.dispatch('loadPlantScenes', this.plantId);
                            break;
                        case 'updateScene':
                            for (var i=0; i< this.tableData.length; i++) {
                                var scene = this.tableData[i];
                                if (scene.sceneId == resp.response.sceneInfo.sceneId) {
                                    this.tableData[i] = resp.response.sceneInfo;
                                    this.$bvModal.hide('modal-edit-scene');
                                    this.$forceUpdate();
                                    break;
                                }
                            }
                            break;
                        case 'removeScene':
                            for (var i=0; i< this.tableData.length; i++) {
                                var scene = this.tableData[i];
                                if (scene.sceneId == resp.response.sceneInfo.sceneId) {
                                    this.tableData.splice(i,1);
                                    this.$forceUpdate();
                                    break;
                                }
                            }
                            break;
                        case 'ATTIVAZIONE SCENA':
                            console.log("Attivata scena");
                            break;
                        }

                }
            }
        }
    },
    methods: {
        accettazioneDisclaimerPhoto()
        {
           var actualDate=new Date();
           console.log("Dispatch accettazione disclaimer",actualDate);
           this.$store.dispatch('dbSaveDisclaimerPhoto',{acceptedDate: actualDate});
        },
        sceneCurrentList(scene)
        {
            console.log("current scene loop", scene);
            var sceneList=[];
            for(var i=0;i<scene.collections.length;i++)
            {
                sceneList.push(scene.collections[i].scene);
            }
            return sceneList;
        },
     onChangeCentEdit(cent_selected) {
      console.log("Cent selected on change: ", cent_selected);
      var cent_sel=[];
      cent_sel=cent_selected.split("_");
      console.log("Cent selected: ", cent_sel.toString());

      var sceneList=[];
      //cerco array di scene per ogni centrale selezionata
      for(var i=0;i<this.$store.state.plantUnits.length;i++)
      {
        if(this.$store.state.plantUnits[i].cu_type == cent_sel[0] && this.$store.state.plantUnits[i].cu_id == cent_sel[1])
        {
          if(this.$store.state.plantUnits[i].scene && this.$store.state.plantUnits[i].scene.length>0)
          {
            for(var j=0;j<this.$store.state.plantUnits[i].scene.length;j++)
            {
                //creo un unico array concatenando le scene
                sceneList=sceneList.concat(this.$store.state.plantUnits[i].scene[j].descrizione.split('$')[1] + " - " + this.$store.state.plantUnits[i].scene[j].descrizione.split('$')[0]);
            }
          }
        }
      }
      //tolgo i valori duplicati nell'array complessivo di tutti i gruppi per la centrale
      sceneList = [...new Set(sceneList)];
      console.log("sceneList: ",sceneList);
      this.scene_options=[];

      for(var i=0;i<sceneList.length;i++)
        {
            this.scene_options.push(sceneList[i]);
        }

      this.$forceUpdate();
      console.log("option_scene",this.scene_options.toString());

    },
        sceneFiltered(id){
            console.log("filter");
            return this.tableData.filter(item => item.ambientId === id)
        },
        getNomeZona(id)
        {
            if (id!=null)
            {
                var zone_selected= this.plantDetails.scenari.filter(item => item.id === id);
                console.log("zone selected",zone_selected[0].name);
                return zone_selected[0].name;
            }

        },
        apertoDettaglioMappa() {
            console.log("Aperto dettaglio " + this.currentAmbiente.isNew);
            this.tabIndex = 0;
            if (this.currentAmbiente.isNew) {
                this.showDropZone = true;
            }
            else
               this.showDropZone = false;
        },
         showModalDisclaimer()
        {
            var acceptedDate= new Date(this.$store.state.user.disclaimerPhotoAccepted);
            if (acceptedDate.getFullYear()>2019 && acceptedDate.getFullYear()<2200)
            {
                console.log("DisclaimerPhoto già accettata in data",acceptedDate);
                this.aggiungiPianta();
            }
            else
            {
                this.$refs['modalDisclaimerPhoto'].show();
            }
        },
        accettazioneDisclaimerPhoto()
        {
           var actualDate=new Date();
           console.log("Dispatch accettazione disclaimer",actualDate);
           this.$store.dispatch('dbSaveDisclaimerPhoto',{acceptedDate: actualDate});
        },
        aggiungiPianta() {

            const plant = this.$store.state.currentPlant;
            var mappe = plant[this.section];
            let numMappe = (mappe == null) ? 0 : mappe.length;
            if (this.$store.getters.isProExpired) {

                if (numMappe >= this.$store.state.appConfig.maxPlants) {
                    this.$bvModal.msgBoxConfirm("Funzionalità PRO Scadute. Per ripristinare le funzionalità rinnova il servizio PRO.", {
                        title: 'Limite ' + this.section + ' raggiunto',
                        okVariant: 'success',
                        okTitle: 'Rinnova PRO',
                        cancelTitle: 'CHIUDI',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                        //this.$root.$emit('openSettingsEvent');
                        this.$router.push({
                            name: "GeneraliImpianto",
                            params: { plantId: this.$store.state.currentPlant.id }
                        });
                        }
                    });
                    return;
                }


            }


            if (plant.plant_type == 'basic') {
                if (numMappe >= this.$store.state.appConfig.maxPlants) {
                    var msg = (this.$store.state.appConfig.maxPlants > 0) ? "Su impianti Basic è possibile configurare un massimo di " + this.$store.state.appConfig.maxPlants + " " + this.section : "Funzionalità disponibile solo su impianti PRO";

                    this.$bvModal.msgBoxConfirm(msg, {
                        title: 'Limite ' + this.section + ' raggiunto',
                        okVariant: 'success',
                        okTitle: 'Passa a PRO',
                        cancelTitle: 'CHIUDI',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                        //this.$root.$emit('openSettingsEvent');
                        this.$router.push({
                            name: "GeneraliImpianto",
                            params: { plantId: this.$store.state.currentPlant.id }
                        });
                        }
                    });
                    return;
                }
            }

            const pianta = {
                id: parseInt(Math.random() * 10000),
                name: "",
                lamps: [],
                isNew: true
            };

            if (mappe == null)  {
                Vue.set(this.$store.state.currentPlant,this.section,[]);
                mappe = this.$store.state.currentPlant[this.section];
            }
            mappe.push(pianta);
            this.imgUploaded = false;
            this.apriModal(mappe.length-1);

        },
        picReady(id) {
            console.log("picReady " + id, this.picLoaded);
            Vue.set(this.picLoaded,'pic'+id,id);
            //this.$forceUpdate();
        },
        eliminaAmbiente(ambiente,index) {
            const self = this;
            this.$bvModal.msgBoxConfirm('Sicuro di vole eliminare questo ambiente?', {
                    title: 'Attenzione!',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'ELIMINA',
                    cancelTitle: 'ANNULLA',
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(value => {
                    console.log("risposto con:" + value);
                    if (value) {
                        self.$store.state.currentPlant[self.section].splice(index,1);
                        self.$store.dispatch("aggiornaMappe",{plantId: self.plantDetails.id, mapType: self.section, maps: self.$store.state.currentPlant[self.section]});
                    }
                });
        },
        chiudiDettaglioMappa(ev) {
            console.log("chiuso dettaglio mappa", ev , "ambiente corrente: ", this.currentAmbiente);
            const self = this;
            if (this.currentAmbiente == null) return;
            if (this.currentAmbiente.name.trim() == '') {
                ev.preventDefault();
                this.$bvModal.msgBoxConfirm(this.$t('scenario.warning_zone'), {
                    title: this.$t('scenario.warning'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'OK',
                    cancelTitle: this.$t('scenario.close').toUpperCase(),
                    footerClass: 'p-2',
                    hideHeaderClose: true,
                    centered: true
                })
                .then(value => {
                    console.log("risposto con:" + value);
                    if (! value) {
                        //chiudo la modale ed elimino l'ambiente aggiunto
                        self.$store.state.currentPlant[self.section].pop();
                        self.currentAmbiente = null;
                        self.$bvModal.hide('modal-scenario');
                        self.$forceUpdate();
                    }
                })
                return;
            }
                var mappe = this.plantDetails[this.section];
                this.currentAmbiente.isNew = false;

                this.$store.dispatch("aggiornaMappe",{plantId: this.plantDetails.id, mapType: this.section, maps: mappe});
                self.$bvModal.hide('modal-scenario');
            },
            bigImgLoaded() {
            const elem = document.getElementById("imgBig");
            if (elem == null) return;
            console.log("image loaded " + elem.src);

            //rimuovi filtri lampade non assegnate nei tab 0 e 1 (da usare solo nel tab 2)
            console.log("tabIndex",this.tabIndex);
            if(this.tabIndex!=2)
            {
                this.filtroLampadeLibere=false;
                this.filtro="";
            }

            if (elem.src.indexOf('empty_map') > 0) return;
            this.imgLoaded = true;
        },
        closeDropZone() {
            this.showDropZone = false;
            this.$refs.myVueDropzone.removeAllFiles();
        },
        uploadImg() {
            console.log("upload img")
            this.showDropZone = true
        },
           sendingImage(file,xhr,formData) {
            console.log("sendingImage",file,xhr,formData);
            console.log(file.type, file.dataURL);
            const buf = Buffer.from(file);
            console.log(buf.toString('base64'));
            //xhr.setRequestHeader("Content-Type","application/json")
        },
        fileAdded(file,dataUrl) {
            console.log("file added",file);
            const self = this;
            const reader = new FileReader();
            reader.onloadend = function(result) {
                console.log("result:",result);
                self.axios.post('', {
                    action: 'uploadImage',
                    plantId: self.plantDetails.id,
                    type: self.section,
                    resId: self.currentAmbiente.id,
                    data: result.target.result
                })
                    .then(function (response) {
                        console.log("post eseguita",response);
                        self.$nextTick(() => {
                            self.showDropZone = false;
                            self.$refs.myVueDropzone.removeAllFiles();
                            self.imgUploaded = true;
                            self.$forceUpdate();
                        });
                    })
                    .catch(function (error) {
                        console.log("errore post",error);
                    });


            }
            reader.readAsDataURL(file);

        },
        imageUrl(ambid) {
            if (this.currentAmbiente != null && this.currentAmbiente.id == ambid) {
                console.log("imageUrl, isNew=" + this.currentAmbiente.isNew + "," + this.imgUploaded + ", lambdaUrl=" + process.env.VUE_APP_API_REST_URL);
                if (this.currentAmbiente.isNew && !this.imgUploaded) {
                    return "/img/empty_map.jpg";
                }
            } else {
                console.log("lamda_url:" + process.env.VUE_APP_API_REST_URL);
                return process.env.VUE_APP_API_REST_URL + "?action=getResource&type="+this.section+"&id="+this.plantId+"-"+ambid+"&rnd=" + Math.random();
            }
            return process.env.VUE_APP_API_REST_URL + "?action=getResource&type="+this.section+"&id="+this.plantId+"-"+ambid+"&rnd=" + Math.random();
        },
        selectAllDays() {
            console.log("actual days=", this.currentScene.program.days)
            this.currentScene.program.days = ['1','2','3','4','5','6','7'];
        },
        buildTimeDiffOptions() {
            this.timeDiffOptions = [];
            for (var i=-60; i<=60; i+= 5) {
                this.timeDiffOptions.push({value: i, text: ((i>0) ? "+" : "") + i + " min"});
            }
        },
        loadData() {
            if (this.plantDetails == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
                return false;
            } else if (this.unitsDetails==null) {
                this.$store.dispatch('loadUnitsDetails', this.plantId);
                return false;
            } else if (this.sceneDetails == null) {
                console.log("ricarico plant scenes");
                this.$store.dispatch('loadPlantScenes', this.plantId)
                return false;
            } else {
                console.log("scenari dati pronti")
                //this.$forceUpdate();
            }
            return true;
        },
        openNewScene() {
            this.saveSubmit = false;
            this.currentScene = {
                sceneId: null,
                plantId: this.$store.state.currentPlant.id,
                sceneName: '',
                collections: [],
                sceneEnabled: true,
                sceneMode: '',
                sceneInput: '',
                program: {
                    timeDiff: 0
                }
            }
            this.itemsCollection = [
                {collection: '', level: 'off'}
            ];
            console.log("openNewScene");

            this.$bvModal.show('modal-edit-scene');

        },
        editScene(scene) {
            /*this.saveSubmit = false;*/
            this.currentScene = JSON.parse(JSON.stringify(scene));
            /*this.itemsCollection = scene.collections.map((s) => {
                return {collection: s};
            });
            this.itemsCollection = scene.collections;*/
            console.log("openEditScene");
            this.cu_options=this.cuIdList;
            console.log("scena aperta",scene);
            this.scene_options=this.sceneCurrentList(scene);

            this.$bvModal.show('modal-edit-scene'+this._uid);

        },
         handleOk(bvModalEvt) {
            // Prevent modal from closing
            console.log("Salvo la scena aggiornata");
            bvModalEvt.preventDefault();
            this.saveSubmit = true;
            // Trigger submit handler
            this.saveScene();
        },
        saveScene() {
            console.log("Save scene");
            if (!this.validation_sceneName || !this.validation_collectionCu || !this.validation_collectionScene) return;

            this.currentScene.type="Cu";
            this.currentScene.sceneEnabled=false;
            //this.currentScene.collections=this.itemsScene;

            console.log("update scene...");
            this.$store.dispatch("dbUpdateScene", this.currentScene);

            // Hide the modal manually
                    this.$nextTick(() => {
                    this.$refs.modal.hide();
                    });
         },
         activateScene(scene) {
            let self = this;
            let cu_command="activateScene"
            let delay=0;
            for(var k=0;k<scene.collections.length;k++)
            {
              let num_scene=(scene.collections[k].scene.split("-")[0]).trim();
              let cu_type=scene.collections[k].cu.split("_")[0];
              let cu_id=scene.collections[k].cu.split("_")[1];
              setTimeout(function() {
                console.log("Activate scene (cutype,cuid,scene): ",cu_type,cu_id,num_scene);
                    self.$store.dispatch('sendCablecomCommand', {cu_command,cu_type: cu_type, cu_id: cu_id, addr: num_scene});
                },delay);
              delay=delay+3000;

            }
            // Hide the modal manually
                    this.$nextTick(() => {
                        this.$bvModal.hide('modal-scenario')
                    });
         },
        /*handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            this.saveSubmit = true;

            if (!this.validation_sceneName || !this.validation_mode || !this.validation_days || !this.validation_timeMode || !this.validation_input)  {
                console.log("validation_mode=" + this.validation_mode +", validation_days:" + this.validation_days+", validation_timeMode:"+this.validationTimeMode+", validation_input:"+this.validation_input);
                return;
            }

            //save
            //this.currentScene.collections = this.itemsCollection.map((c) => c.collection);
            this.currentScene.collections = this.itemsCollection;

            if (this.currentScene.sceneId == null) {
                this.currentScene.sceneId = '' + uuid.v1();
                this.$store.dispatch("dbSaveScene", this.currentScene);
            } else {
                console.log("update scene...");
                this.$store.dispatch("dbUpdateScene", this.currentScene);
            }

        },*/
        addInput()
        {
            var newItem={ cu: '', scene: ''};
            this.itemsScene.push(newItem);
        },
        addInputCollection(pos)
        {
            var selEl = this.itemsCollection[pos];
            if (selEl.collection == '')  {
                this.$bvModal.msgBoxOk('Occorre selezionare una aggregazione', {
                    title: 'Attenzione',
                    size: 'sm',
                    xxbuttonSize: 'sm',
                    xxokVariant: 'success',
                    centered: true
                });
                return;
            }

            var newItem={ collection: ''};
            this.itemsCollection.push(newItem);
        },

        removeScene(scene)
        {
            console.log("Remove scene: ",scene);
            let self = this;
            this.$bvModal.msgBoxConfirm("Eliminare questo scenario?", {
                        title: 'Conferma',
                        okVariant: 'danger',
                        okTitle: 'ELIMINA',
                        cancelTitle: 'ANNULLA',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                            self.$store.dispatch("dbRemoveScene", {
                                plantId: self.$store.state.currentPlant.id,
                                sceneId: scene.sceneId,
                            });
                        }
                    });
        },
        filtra(){
            //TODO come aggregazioni?
        },
        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0)
            {
               return user[0].role;
            }
            return "?";
        },

        apriModal(index) {
            console.log("apro modal " + index);

            this.currentAmbiente = this.ambienti[index];

            let self = this;
            this.imgLoaded = false;
            window.setTimeout(function() {
                self.$bvModal.show('modal-scenario');
            }, 100);
        }
    }
}
</script>

<style lang="scss">

    .datepicker-orario, .datepicker-data {
        button {
            .b-icon {
                color: #000!important;
            }
        }
    }



    .modal-xl {
        max-width: 95%;

    }


    .infoTip {
        position: absolute;
        right: 5px;
        bottom: 5px;
    }

    .closeButton {
        position: absolute;
        right: 0;
        top: 0;
    }


    .highlightedRow {
        background-color: #b3d3ec;
    }

    .highlightedAdded {
        background-color: #ffff;
    }


    .green {
        color: #009900;
    }
    .error {
        color: #cc0000;
    }

    .uploadButton {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .infoTip {
        position: absolute;
        right: 5px;
        bottom: 5px;
    }

    .closeButton {
        position: absolute;
        right: 0;
        top: 0;
    }


.modal-fullscreen .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 100000;
}

.nopad {
       padding: 0;
    }
    .imgDiv {
        position: relative;
    }

    .dotImg {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 13px;
        height: 13px;

    }

    @keyframes highlightedDotAnim {
        0% {background-color: rgba(255,255,255,0);}
        50% {background-color: rgba(255,255,0,0.8);}
        100% {background-color: rgba(255,255,255,0);}
    }

    .dotImgHighlight {
        background-color: #ffff00;
        width: 61px;
        height: 61px;
        padding: 24px;
        border-radius: 32px;
        animation-name: highlightedDotAnim;
        animation-duration: 1s;
        animation-iteration-count: infinite;
    }

    .dotImgBig {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 50px;
        height: 50px;
        padding: 16px;
        background-color: #ffffff11;
        border-radius: 32px;
        z-index: 10000;
    }

    .dotSel {
        background-color: #00990044;
    }

    .modal-xl {
        max-width: 95%;
    }
    .uploadButton {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .infoTip {
        position: absolute;
        right: 5px;
        bottom: 5px;
    }

    .closeButton {
        position: absolute;
        right: 0;
        top: 0;
    }

    #dropzoneContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #eeeeee;
        top: 0;
        margin-top: auto;
        margin-bottom: auto;
        padding: 16px;
        z-index: 11000;
    }
    #dropzone {
        height: 100%;
    }
    .draggableRow {
        cursor: pointer;
    }
    .lampUsed {
        background-color: #ffff;
    }

    .highlightedRow {
        background-color: #b3d3ec;
    }

    .highlightedAdded {
        background-color: #ffff;
    }
    .green {
        color: #009900;
    }
    .error {
        color: #cc0000;
    }

    #modal-ambiente .modal-content {
        min-height: 600px;
    }

</style>
